<template>
    <div class="my">
        <nav-bar title="活动详情"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav"/>
        <div style="height: 3rem"></div>
        <!-- 上滑进入 -->
        <cell-group title="活动信息">
            <cell title="活动名称" :value="activity.activityName"/>
            <cell title="人数上限" :value="activity.numberPeople"/>
            <cell title="开始时间" :value="ptime(activity.activityStartTime)"/>
            <cell title="结束时间" :value="ptime(activity.activityEndTime)"/>
            <div class="ql-container ql-snow" style="border:none">
                <div class="ql-editor" data-gramm="false" contenteditable="true"
                     v-html="activity.activityContent">
                </div>
            </div>
            <ant-button @click="showPopup" type="danger" block >活动车辆</ant-button>
        </cell-group>
        <!-- 上滑进入 -->
        <cell-group title="我报名的人员">
            <div v-for="(v,i) in list">
                <divider dashed style="float:left;">参加人员{{i+1}}</divider>
                <ant-button
                        style="float:right;margin-top:10px;margin-right:10px;"
                        :loading="loading"
                        @click="moveaction(v)" size="small" class="btn">移除报名</ant-button>

                <cell title="姓名" :value="v.userName"/>
                <cell title="手机号" :value="v.phone"/>
                <cell title="公司" :value="v.company"/>
                <cell title="备注" :value="v.remark"/>

            </div>
        </cell-group>
    </div>
</template>

<script>
    import service from "../../api/service";
    import {Cell, CellGroup, NavBar, Divider, Button, Toast,} from 'vant'
    import moment from "moment";
    //活动详情
    export default {
        name: "moveDetail",
        components: {
            Cell, CellGroup,
            NavBar, Divider,
            AntButton: Button,
        },
        data() {
            return {
                loading:false,
                activity: {},
                list: [],
                show: false,
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity/getById',
                    {
                        id: sessionStorage.getItem("proId"),
                    }).then(res => {
                    if (res.status === 200) {
                        this.activity = res.data
                        console.log(res.data)
                    }
                })
                service.get('/api/activity/listOfPeopleISignedUp', {
                    activityId: sessionStorage.getItem("proId"),
                    openid: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data

                    }
                })
            }, //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
            showPopup() {
                this.$router.push({path: '/carList'})
            },
            ptime(v) {
                let d = Number(v)
                return v ? moment(d).format("YYYY-MM-DD HH:mm:ss") : '-';
            },
            moveaction(v){
                this.loading = true;
                service.get('/api/activity/delectapply', {
                   id:v.id
                }).then(res => {
                    if (res.status === 200) {
                        this.loading = false;
                        this.init();
                        Toast.success(res.message)
                    }else{
                        this.loading = false;
                        Toast.fail(res.message)
                    }
                })

            }
        },

    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }


</style>